import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useGame } from "@/context/GameContext";

export default function GiftPopup() {
  const { user, refresh } = useGame();
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/gifts/unseen").then(({ data }) => setGifts(data)).catch(() => {});
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const close = async () => {
    setGifts([]);
    await api.post("/gifts/seen").catch(() => {});
    window.dispatchEvent(new Event("gift-popup-closed"));
    refresh();
  };
  if (!gifts.length) return null;
  const total = gifts.reduce((s, g) => s + g.amount, 0);
  const messages = gifts.map((g) => g.message).filter(Boolean);

  return (
    <Dialog open onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="gift-popup" className="glass max-w-md text-center">
        <div className="mx-auto w-20 h-20 rounded-full grid place-items-center bg-amber-500/15 border border-amber-400/60 nft-glow mb-2">
          <Gift className="w-9 h-9 text-amber-300" />
        </div>
        <DialogHeader>
          <DialogTitle className="font-display text-3xl text-white text-center" data-testid="gift-popup-title">
            The pack leader sent you <span className="text-amber-300">{total.toLocaleString()}</span> credits!
          </DialogTitle>
          <DialogDescription className="text-slate-300 text-center">
            {messages.length ? messages.map((m, i) => <span key={i} className="block italic">“{m}”</span>) : "They're already in your balance. Spend them on energy, revives and tonics in the store."}
          </DialogDescription>
        </DialogHeader>
        <button data-testid="gift-popup-close-btn" onClick={close} className="ember-btn w-full py-3 rounded-lg text-sm mt-2">CLAIM & CONTINUE</button>
      </DialogContent>
    </Dialog>
  );
}
